import React from 'react'
import IFormFieldProps from 'interfaces/form-field-props'
import ErrorField from '../error-field/ErrorField'
import InputLabel from '../input-label/InputLabel'
import styles from './SwitchCustom.module.scss'
import Button from 'design-system/button'
import { ButtonSizes, ButtonVariant } from 'design-system/button/src/Button'

interface ICustomSwitch extends IFormFieldProps {
  options: any[]
  className?: string
  disabledMessage?: string
  tooltipMessage?: string
}

const SwitchCustom: React.FC<ICustomSwitch> = ({ className = '', options, value, label, disabled, onChange, error = '', disabledMessage, tooltipMessage }) => {
  return (
    <div className={className}>
      {label && <InputLabel label={label} tooltip={tooltipMessage} className={className} />}
      <div className="mt-2 switchButtons">
        <Button
          size={ButtonSizes.ExtraSmall}
          variant={ButtonVariant[value ? 'Primary' : 'Secondary']}
          className={`${styles.switchButton} ${styles.leftButton}`}
          onClick={() => !disabled && onChange(!value)}
          disabled={disabled}
        >
          {value && options[0]}
        </Button>
        <Button
          size={ButtonSizes.ExtraSmall}
          variant={ButtonVariant.Secondary}
          className={`${styles.switchButton} ${styles.rightButton} ${!value ? styles.offSelected : ''}`}
          onClick={() => !disabled && onChange(!value)}
          disabled={disabled}
        >
          {!value && options[1]}
        </Button>
      </div>
      <div className={styles.disabledMessage}>{disabled && disabledMessage}</div>

      <ErrorField text={error} />
    </div>
  )
}

export default SwitchCustom
